import React from 'react';
import PropTypes from 'prop-types';
import {FileUploadWithModal} from '@/components/organisms';
import {Constants} from '@/utils/constants/commonConstants';

const BulkPointModifierUploadModal = ({
  formData,
  customUploadFile,
  customErrorMessages,
  ...modalProps
}) => (
  <FileUploadWithModal
    title='Upload File'
    fileType='csv'
    uploadFor={Constants.BulkModifiers}
    isCsvValidationRequired={false}
    customUploadFile={customUploadFile}
    formData={formData}
    files={
      formData?.targetMediaFile?.[0] ? formData.targetMediaFile : undefined
    }
    customErrorMessages={customErrorMessages}
    {...modalProps}
  />
);

BulkPointModifierUploadModal.propTypes = {
  formData: PropTypes.shape({
    targetMediaFile: PropTypes.array,
    storeList: PropTypes.string
  }),
  customUploadFile: PropTypes.func.isRequired,
  customErrorMessages: PropTypes.object,
  openUpload: PropTypes.bool.isRequired,
  setOpenUpload: PropTypes.func.isRequired,
  setFormData: PropTypes.func.isRequired
};

export default React.memo(BulkPointModifierUploadModal);
